import type { ImageAsset, Testimonial } from '../types/content';

/** Pagine interne reali della guida principale (formato verticale 3:4). Vuoto = blocco nascosto. */
export const guideInteriorPages: ImageAsset[] = [];

/** Selezione di modelli reali della raccolta 100+ (formato verticale 3:4). Vuoto = blocco nascosto. */
export const templateSamples: ImageAsset[] = [];

/**
 * Immagine illustrativa generata, NON renderizzata e NON è la foto di una cliente.
 * Riservata a una futura testimonianza autentica: da mostrare sempre con l’etichetta.
 */
export const testimonialIllustrationPending = {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/3b4a44ab-eea8-4287-a13e-909bb8b4d469.jpg',
  alt: 'Immagine illustrativa: piccola creazione floreale con effetto vetrata su una credenza in legno, con centrino all’uncinetto, limoni e brocca in ceramica, alla luce naturale',
  label: 'Immagine illustrativa',
  isIllustration: true,
} as const;

/**
 * Testimonianze fornite come reali dalla proprietaria. Nomi ed età
 * confermati dalla proprietaria (lo specchio resta senza nome).
 * Le immagini sono illustrazioni generate, non le creazioni delle clienti.
 */
export const testimonials: Testimonial[] = [{
  id: 't1',
  quote: 'Era la prima volta che lavoravo sul vetro, e le guide passo dopo passo mi hanno davvero semplificato le cose, anche a più di 50 anni! 😅',
  name: 'Alessandra',
  context: '52 anni'
}, {
  id: 't2',
  quote: 'Ho realizzato questo regalo fatto in casa per un’amica, e ho già voglia di crearne altri cento per me! 🙌',
  name: 'Chiara',
  context: '43 anni',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c2e77728-7730-4980-bafe-150e86b27d29.jpg',
  imageAlt: 'Immagine illustrativa: barattolo-lanterna in vetro dipinto con farfalle colorate a effetto vetrata, legato con spago e cartellino regalo, accanto a una scatola in kraft',
  imageIsIllustration: true
}, {
  id: 't5',
  quote: 'Un ottimo acquisto per chi vuole iniziare a creare con le proprie mani. Il mio primissimo hobby creativo 🤞🏻',
  name: 'Paola',
  context: '61 anni'
}, {
  id: 't6',
  quote: 'Ho realizzato questo specchio da sola!! È così bello che sembra comprato in negozio!!!!',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/90dfe542-7b9d-4887-a1ee-dc406f47bfed.jpg',
  imageAlt: 'Immagine illustrativa: specchio rotondo con la cornice dipinta a effetto vetrata, appeso in un soggiorno accogliente',
  imageIsIllustration: true
},
// Testimonianze italiane reali fornite dalla proprietaria (testi invariati).
{
  id: 'it-giulia',
  quote: 'All’inizio pensavo che avrei fatto fatica a seguire le linee 😅. La prima mi è venuta un po’ storta, ma una volta aggiunto il colore il risultato mi è piaciuto tanto. Adesso ho il mio angolino con tutto l’occorrente e ci lavoro un po’ alla volta.',
  name: 'Giulia',
  context: '48 anni'
}, {
  id: 'it-francesca',
  quote: 'Ho fatto un quadretto con dei fiori da mettere vicino alla finestra. Non è perfetto, ma quando ci passa la luce è proprio bello. Mia figlia mi ha chiesto dove l’avessi comprato… che soddisfazione dirle che l’avevo fatto io 🥰.',
  name: 'Francesca',
  context: '56 anni',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/3770c920-2ae1-4f38-824c-d7f11ffe3a2d.jpg',
  imageAlt: 'Immagine illustrativa: quadretto floreale con effetto vetrata in una cornice di legno chiaro, sul davanzale di una finestra con tenda di lino e basilico, attraversato dalla luce',
  imageIsIllustration: true
}, {
  id: 'it-elena',
  quote: 'Cercavo qualcosa da fare la sera senza finire di nuovo al telefono. Mi è piaciuto poter stampare il disegno e partire da quello, perché disegnare non è proprio il mio forte 😂. Vado piano, ma quel momento per dipingere ormai me lo tengo tutto per me.',
  name: 'Elena',
  context: '39 anni'
}];
